import React, { useEffect, useState } from 'react';
import { faLightbulb } from '@fortawesome/free-solid-svg-icons';
import { Form } from 'react-bootstrap';
import FormControls from './'

const CheckBoxGroup = React.memo((props) => {

    const [isInvalid, setIsInvalid] = useState(false);

    const setValue = (val) => {
        let curValue = props.formHandler.values[props.name];
        if(Array.isArray(curValue)) {
            curValue = [...curValue];
            const idx = curValue.indexOf(val);
            if(idx > -1){
                curValue.splice(idx, 1);
            } else {
                curValue.push(val);
            }
        }

        props.formHandler.setFieldValue(props.name, curValue, true)
    }

    useEffect(() => {
        const invalid = props.formHandler.touched[props.name] && props.formHandler.errors[props.name];
        setIsInvalid(invalid);
    }, props.formHandler.errors[props.name])

    return (
        <>
            <Form.Label >{props.label}</Form.Label>
            <div
                className={isInvalid?"text-danger":""}
                name={props.name}
                onBlur={props.formHandler.handleBlur}
                isInvalid={isInvalid}>
                {
                    props.options?.map(opt => (
                        <Form.Check
                            id={props.id ?? ('checkBox' + props.label + opt.value)}
                            type="checkbox"
                            label={opt.name}
                            className={props.className ? props.className + " pointer-mouseover" : "pointer-mouseover"}
                            placeholder={props.placeholder}
                            value={opt.value}
                            onChange={() => setValue(opt.value)}
                            onBlur={props.formHandler.handleBlur}
                            checked={props.formHandler.values[props.name] && props.formHandler.values[props.name].includes(opt.value)}
                            name={props.name}
                        />)
                    )
                }
            </div>
            <FormControls.Feedback 
                name="roleIds"
                formHandler={props.formHandler} />
        </>
    );
})

export default CheckBoxGroup;
